import { render, staticRenderFns } from "./distributed.vue?vue&type=template&id=50f84930"
import script from "./distributed.vue?vue&type=script&lang=js"
export * from "./distributed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports